import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';

// Local replacement for @appucations/core molecules/modal/error (package no
// longer available). Built on the tool's own react-bootstrap stack, matching
// the modal convention in src/containers/user. The `appElement` prop is
// accepted for call-site compatibility and ignored — react-bootstrap renders
// its own portal, so no react-modal app element is needed.
const ErrorModal = ({
  title,
  description,
  children,
  modalIsOpen,
  setModalIsOpen,
  accept,
  appElement, // eslint-disable-line no-unused-vars
}) => {
  const { t } = useTranslation();

  const close = () => {
    if (setModalIsOpen) setModalIsOpen(false);
    if (accept) accept();
  };

  return (
    <Modal show={!!modalIsOpen} onHide={close} centered>
      {title && (
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>
        {description && <div className="error-description">{description}</div>}
        <div className="error-messages">{children}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={close}>
          {t('ok', 'OK')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;
